// @ts-nocheck
import React, { useState } from 'react'
import { Page } from '../components/ui/Page'
import { IconCheck, IconXError } from '../components/Icons'
import Store from '../store/Store'
import { Body } from '../components/layout/Body';

export default function ContactPage() {
	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [subject, setSubject] = useState('')
	const [message, setMessage] = useState('')
	const [formStatus, setFormStatus] = useState<{ type: 'success' | 'error'; text: string } | null>(null)

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault()
		setFormStatus(null)
		const trimmedName = name.trim()
		const trimmedEmail = email.trim()
		const trimmedSubject = subject.trim()
		const trimmedMessage = message.trim()
		if (!trimmedEmail.includes('@') || trimmedMessage.length === 0 || trimmedSubject.length === 0 || trimmedName.length === 0) {
			setFormStatus({ type: 'error', text: 'Bitte geben Sie eine gültige E-Mail und eine Nachricht an.' })
			return
		}
		try {
			await Store.fetchSession()
			const result = await Store.fetch('contact', {
				method: 'POST',
				body: JSON.stringify({
					name: trimmedName,
					email: trimmedEmail,
					subject: trimmedSubject,
					message: trimmedMessage,
				}),
			})
			if (result?.status === 'ok' || result) {
				setFormStatus({ type: 'success', text: 'Danke! Ihre Nachricht wurde versendet.' })
				setName('')
				setEmail('')
				setSubject('')
				setMessage('')
			} else {
				setFormStatus({ type: 'error', text: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.' })
			}
		} catch (err) {
			setFormStatus({ type: 'error', text: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut.' })
		}
	}

	return (
		  <div className="max-w-[1200px] mx-auto">
					<Page>
						<Body>
							<h1 className='text-2xl mt-16 mb-8 font-bold'>Kontakt</h1>
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 w-full relative">
					{/* Left column */}
					<div className="flex flex-col gap-4">
						<p className="text-gray-600">
							Sie haben Fragen zu unseren Leistungen oder wünschen ein individuelles Angebot,
							dann nehmen Sie gerne Kontakt mit uns auf. Wir freuen uns über Ihre Anfrage
							und melden uns so schnell wie möglich bei Ihnen zurück.
						</p>
						<p className="text-gray-600">
							Nutzen Sie einfach das folgende Kontaktformular oder schreiben Sie uns direkt
							eine E-Mail.
						</p>
					</div>

					{/* Right column – contact form */}
					<form className="flex flex-col gap-5" onSubmit={onSubmit}>
						<div className="flex flex-col gap-1">
							<label className="font-semibold text-lg mb-3">Name*</label>
							<input
								type="text"
								className="border rounded-full px-4 py-3 text-sm outline-none"
								style={{ borderColor: '#333333' }}
								placeholder="Bitte geben Sie Ihren vollständigen Namen ein."
								value={name}
								onChange={e => setName(e.target.value)}
								required
							/>
						</div>

						<div className="flex flex-col gap-1">
							<label className="font-semibold text-lg mb-3">E-Mail-Adresse*</label>
							<input
								type="email"
								className="border rounded-full px-4 py-3 text-sm outline-none"
								style={{ borderColor: '#333333' }}
								placeholder="Bitte geben Sie Ihre E-Mail-Adresse ein."
								value={email}
								onChange={e => setEmail(e.target.value)}
								required
							/>
						</div>

						<div className="flex flex-col gap-1">
							<label className="font-semibold text-lg mb-3">Betreff*</label>
							<input
								type="text"
								className="border rounded-full px-4 py-3 text-sm outline-none"
								style={{ borderColor: '#333333' }}
								placeholder="Worum geht es in Ihrer Anfrage?"
								value={subject}
								onChange={e => setSubject(e.target.value)}
								required
							/>
						</div>

						<div className="flex flex-col gap-1">
							<label className="font-semibold text-lg mb-3">Nachricht*</label>
							<textarea
								rows={5}
								className="border rounded-2xl px-4 py-3 text-sm outline-none resize-y"
								style={{ borderColor: '#333333' }}
								placeholder="Beschreiben Sie kurz Ihr Anliegen."
								value={message}
								onChange={e => setMessage(e.target.value)}
								required
							/>
						</div>

						<p className="text-xs text-gray-500">
							Mit dem Absenden des Formulars erklären Sie sich damit einverstanden,
							dass Ihre angegebenen Daten zur Bearbeitung Ihrer Anfrage gespeichert
							und verarbeitet werden. Weitere Informationen finden Sie in unserer
							Datenschutzerklärung.
						</p>

						<div className="flex justify-end">
							<button
								type="submit"
								className="bg-[#E1320F] hover:bg-[#c42b0d] text-white rounded-full px-12 py-3 text-sm font-medium transition-colors mt-5"
							>
								Absenden
							</button>
						</div>
						{formStatus && (
							<div className={
								'inline-flex gap-2 p-1 items-center mt-2 ' +
								(formStatus.type === 'success'
									? 'text-green-700'
									: 'text-red-700')
							}>
								{formStatus.type === 'success' && <IconCheck />}
								{formStatus.type === 'error' && <IconXError />}
								<p className="m-0">{formStatus.text}</p>
							</div>
						)}
					</form>
				</div>
			</Body>
		</Page>
		</div>
	)
}
